(function ($) {
  $(document).ready(function () {
    /* REVIEWS/MEDIA/VIDEO SWAP */

    $(".video-embed").on("click", function () {
      var vid = $(this).find("video");
      if (vid.length > 0) {
        vid.addClass("playing");
        vid.on("click", function (e) {
          e.stopPropagation();
        });
        if (vid[0].playing) {
          vid[0].pause();
        } else {
          vid[0].play();
        }
      } else {
        var iframe = $(this).find("iframe");

        // in the partials/embed-video.twig template
        if (iframe.length > 0) {
          if (iframe.attr("src").indexOf("player.vimeo.com") != -1) {
            if (typeof Vimeo !== "undefined") {
              iframe.addClass("playing");
              var player = new Vimeo.Player(iframe);
              player.play();
            } else {
              alert(
                "We're having a little trouble connecting to Vimeo, please try again in a few minutes!"
              );
            }
          }
        }
      }
    });

    // Smaller videos you're supposed to click on to show a bigger one

    $(".video-teaser").on("click", function () {
      // visual feedback
      $(".video-teaser").removeClass("active");
      $(this).addClass("active");
      // video-[item->ID]
      var id = $(this).data("video");
      if (id.length === false) {
        return false;
      }

      var iframe = $("iframe.playing");
      if (iframe.length > 0) {
        iframe.removeClass("playing");
        if (iframe.attr("src").indexOf("player.vimeo.com") != -1) {
          if (typeof Vimeo !== "undefined") {
            var player = new Vimeo.Player(iframe);
            player.unload();
          } else {
            alert(
              "We're having a little trouble connecting to Vimeo, please try again in a few minutes!"
            );
          }
        }
      }

      var container_id = "video-full-" + id;
      // remove all, then target the current one
      $(".video-full").removeClass("active");
      $("#" + container_id).addClass("active");
      $("html, body").animate(
        {
          scrollTop: $("#" + container_id).offset().top - 140,
        },
        800
      );
    });
  });
})(jQuery);
